export default {
  common: {
    filters: {
      startingDate: {
        label: 'Starting date',
        placeholder: 'YYYY-MM-DD hh:mm:ss'
      },
      endDate: {
        label: 'End date',
        placeholder: 'YYYY-MM-DD hh:mm:ss'
      },
      statuses: {
        label: 'Status(es)',
        placeholder: 'Select status(es)'
      },
      operationIds: {
        label: 'Operation Id(s)',
        placeholder: 'Enter operation id(s)'
      },
      customer_msisdn: {
        label: 'Customer phone number',
        placeholder: 'Enter customer phone number'
      },
      provider_name: {
        label: 'Provider(s) name',
        placeholder: 'Select provider(s) name'
      },
      resultsNumber: {
        label: 'Number of results to display at page'
      }
    }
  }
};
